import { render, staticRenderFns } from "./StudentRoleManage.vue?vue&type=template&id=c6a19ea8&scoped=true&"
import script from "./StudentRoleManage.vue?vue&type=script&lang=js&"
export * from "./StudentRoleManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a19ea8",
  null
  
)

export default component.exports